import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import TableComponent from '../../Layouts/TableComponent';
import Avatar from '@material-ui/core/Avatar';
import Tooltip from '@material-ui/core/Tooltip';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import ls from 'local-storage';
import AuthCheckComponent from '../../Layouts/Token';
import PageLoader from '../../Layouts/PageLoader';
import moment from 'moment';

import './TaskManagement.css';
import '../Leaves/Leave.css';
import '../Attendance/Attendance.css';
import './job.css';
import '../LeavesTicket/Ticket.css';
import '../Users/user.css';
import { isProjectActive } from '../../../utils/projectStatus';
import defaultAvatar from '../../../Images/person.jpg';
import { resolveImageUrl } from '../../../utils/imageUrl';
import { parseTimelineHoursMinutes } from './TimelineInputField';

const PROJECT_TABLE_HEADERS = [
  { id: 'select', numeric: false, disablePadding: true, label: '', sortable: false, style: { width: '50px', minWidth: '50px', textAlign: 'center' } },
  { id: 'sr_no', numeric: false, disablePadding: true, label: 'Sr. No.', sortable: true, style: { width: '70px', minWidth: '70px', textAlign: 'center' } },
  { id: 'project_name', numeric: false, disablePadding: true, label: 'Project Name', sortable: true, style: { minWidth: '150px' } },
  { id: 'start_date', numeric: false, disablePadding: true, label: 'Start Date', sortable: true, style: { minWidth: '110px' } },
  { id: 'target_date', numeric: false, disablePadding: true, label: 'End Date', sortable: true, style: { minWidth: '110px' } },
  { id: 'assigned_team', numeric: false, disablePadding: true, label: 'Assigned Team', sortable: false, style: { minWidth: '140px' } },
  { id: 'total_project_time', numeric: false, disablePadding: true, label: 'Total Time', sortable: true, style: { minWidth: '120px' } },
  { id: 'summary', numeric: false, disablePadding: true, label: 'Description', sortable: false, style: { minWidth: '180px' } },
  { id: 'actions', numeric: false, disablePadding: true, label: 'Actions', sortable: false },
];

const ManageProjects = (props) => {
  const [projects, setProjects] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);

  const getInitialStatusFilter = () => {
    try {
      const saved = ls.get('manage_projects_status_filter') || ls('manage_projects_status_filter');
      if (saved && ['All', 'Active', 'Inactive'].includes(saved)) {
        return saved;
      }
    } catch (_) {}
    return 'Active';
  };

  const [statusFilter, setStatusFilter] = useState(getInitialStatusFilter);
  const [searchQuery, setSearchQuery] = useState('');
  const [pageLoading, setPageLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedBulkAction, setSelectedBulkAction] = useState('');


  const isUserSuperAdmin = () => {
    try {
      const roles = ls.get('roles') || ls('roles');
      if (!roles) return false;
      const adminRoles = ['super admin', 'admin', 'administrator'];
      if (typeof roles === 'string') {
        const r = roles.trim().toLowerCase();
        return adminRoles.includes(r);
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  };

  useEffect(() => {
    if (!isUserSuperAdmin()) {
      swal('Access Denied', 'Only administrators can manage projects.', 'warning');
      props.history.replace('/tasks');
      return;
    }
    fetchData(true);
  }, []);

  const fetchData = async (showLoader = false) => {
    if (showLoader) setPageLoading(true);
    try {
      const [projectsRes, usersRes, tasksRes] = await Promise.all([
        AuthApi.getProject(),
        AuthApi.getData(),
        AuthApi.getTasks()
      ]);

      const pData = (projectsRes && projectsRes.data) || (Array.isArray(projectsRes) ? projectsRes : []);
      const allProjects = Array.isArray(pData)
        ? pData.filter((p) => String(p.deleted) !== "1" && p.deleted !== true && p.deleted !== 1)
        : [];
      // Sort newest first
      allProjects.sort((a, b) => Number(b.id || 0) - Number(a.id || 0));
      setProjects(allProjects);

      const uData = (usersRes && usersRes.data) || usersRes || [];
      const allUsers = Array.isArray(uData) ? uData : [];
      setActiveUsers(allUsers);

      if (tasksRes) {
        const rawTasks = (tasksRes && tasksRes.data) || (Array.isArray(tasksRes) ? tasksRes : []);
        setAllTasks(Array.isArray(rawTasks) ? rawTasks : []);
      }
    } catch (err) {
      console.error('Error fetching manage projects data:', err);
    } finally {
      if (showLoader) setPageLoading(false);
    }
  };

  const extractIds = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw
        .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
        .map(Number)
        .filter((id) => !isNaN(id));
    }
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
            .map(Number)
            .filter((id) => !isNaN(id));
        }
      } catch (_) {
        return raw.split(',').map(Number).filter((id) => !isNaN(id));
      }
    }
    if (typeof raw === 'number') return [raw];
    return [];
  };

  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .filter(Boolean)
      .map((part) => part[0].toUpperCase())
      .slice(0, 2)
      .join('');
  };

  const formatDate = (d) => {
    if (!d) return '-';
    try {
      return moment(d).format('DD-MM-YYYY');
    } catch (_) {
      return d;
    }
  };

  const handleToggleProjectStatus = async (project) => {
    const newStatus = project.status === 0 ? 1 : 0;
    const statusLabel = newStatus === 1 ? 'Active' : 'Inactive';
    swal({
      title: `Mark as ${statusLabel}?`,
      text: `Are you sure you want to mark "${project.project_name}" as ${statusLabel}?`,
      icon: "info",
      buttons: ["Cancel", `Yes, Mark as ${statusLabel}`],
    }).then(async (confirm) => {
      if (confirm) {
        swal({
          title: "Loading",
          text: "Updating project status...",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: createSwalLoaderNode()
        });
        try {
          const res = await AuthApi.editProject({ status: newStatus }, project.id);
          if (res && (res.status === true || res.status === 200 || res.success)) {
            swal("Updated!", `Project marked as ${statusLabel}`, "success");
            setProjects((prev) =>
              prev.map((p) => (Number(p.id) === Number(project.id) ? { ...p, status: newStatus } : p))
            );
          } else {
            swal("Error", (res && res.message) || "Failed to update project status", "error");
          }
        } catch (err) {
          console.error("Error toggling project status:", err);
          swal("Error", "Something went wrong while updating project status", "error");
        }
      }
    });
  };

  const handleDeleteProject = (projectId) => {
    const project = projects.find((p) => Number(p.id) === Number(projectId));
    if (!project) return;
    const pName = project.project_name || 'Project';

    // Find all tasks for this project
    const projectTasks = allTasks.filter((t) => {
      const tProj = String(t.project_name || '').trim().toLowerCase();
      const currName = String(project.project_name || '').trim().toLowerCase();
      const tProjId = Number(t.project_id || t.projectId || 0);
      const currId = Number(project.id || 0);
      return (tProj && currName && tProj === currName) || (tProjId && currId && tProjId === currId);
    });

    const pendingTasks = projectTasks.filter((t) => {
      const s = String(t.status || '').trim().toLowerCase();
      return s !== 'done' && s !== 'completed';
    });

    // 1. If project has pending (non-Done) tasks -> BLOCK deletion completely
    if (pendingTasks.length > 0) {
      swal({
        title: "Cannot Delete Project",
        text: `"${pName}" has ${pendingTasks.length} pending / ongoing task(s) (e.g. In Progress, Pending). You cannot delete a project with pending tasks. Please complete or reassign all tasks first.`,
        icon: "warning",
        dangerMode: true,
        button: "OK",
      });
      return;
    }

    // 2. If project has tasks but ALL are Done -> Do not permanently delete; offer to mark Inactive
    if (projectTasks.length > 0) {
      swal({
        title: "Cannot Delete Project",
        text: `"${pName}" has ${projectTasks.length} completed task(s) in its history. Projects with work history cannot be permanently deleted. Would you like to mark this project as Inactive instead?`,
        icon: "info",
        buttons: ["Cancel", "Mark as Inactive"],
        dangerMode: true,
      }).then(async (confirm) => {
        if (confirm) {
          swal({
            title: "Loading",
            text: "Updating project status...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: createSwalLoaderNode()
          });
          try {
            const res = await AuthApi.editProject({ status: 0 }, project.id);
            if (res && (res.status === true || res.status === 200 || res.success)) {
              swal("Updated!", `"${pName}" has been marked as Inactive.`, "success");
              setProjects((prev) =>
                prev.map((p) => (Number(p.id) === Number(project.id) ? { ...p, status: 0 } : p))
              );
            } else {
              swal("Error", (res && res.message) || "Failed to update project status", "error");
            }
          } catch (err) {
            console.error("Error setting project inactive:", err);
            swal("Error", "Something went wrong while updating project status", "error");
          }
        }
      });
      return;
    }

    // 3. Project has 0 tasks -> Safe to permanently delete
    swal({
      title: 'Delete Project?',
      text: `Are you sure you want to delete "${pName}"? There are no tasks associated with this project.`,
      icon: 'warning',
      buttons: ['Cancel', 'Yes, Delete'],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        swal({
          title: 'Loading',
          text: 'Please wait...',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: createSwalLoaderNode()
        });

        try {
          const res = await AuthApi.deleteProject(projectId);
          if (res && (res.status === true || res.status === 200 || res.success)) {
            swal('Deleted!', 'Project deleted successfully', 'success');
            setProjects((prev) => prev.filter((p) => Number(p.id) !== Number(projectId)));
          } else {
            swal('Error', (res && res.message) || 'Failed to delete project', 'error');
          }
        } catch (err) {
          console.error('Error deleting project:', err);
          swal('Error', 'Something went wrong while deleting project', 'error');
        }
      }
    });
  };

  const renderTeamAvatars = (project) => {
    const memberIds = extractIds(project.member_ids || project.members || project.developer_id);
    if (memberIds.length === 0) {
      return <span style={{ color: '#94a3b8', fontSize: '13px' }}>No members</span>;
    }
    const maxShow = 5;
    const shownIds = memberIds.slice(0, maxShow);
    const remaining = memberIds.length - maxShow;

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {shownIds.map((uid, i) => {
            const u = activeUsers.find((user) => Number(user.id) === Number(uid));
            const name = u ? (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name) : `User #${uid}`;
            const photoSrc = (u && u.photo && String(u.photo).trim() !== '') ? resolveImageUrl(u.photo) : defaultAvatar;
            return (
              <Tooltip key={uid} title={name} arrow>
                <Avatar
                  src={photoSrc}
                  imgProps={{
                    onError: (e) => {
                      if (e.target.src !== defaultAvatar) {
                        e.target.src = defaultAvatar;
                      }
                    }
                  }}
                  style={{
                    width: 28,
                    height: 28,
                    marginLeft: i > 0 ? -8 : 0,
                    border: '2px solid #ffffff',
                    backgroundColor: 'transparent',
                    zIndex: maxShow - i,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
                  }}
                />
              </Tooltip>
            );
          })}
          {remaining > 0 && (
            <Tooltip title={`${remaining} more members`} arrow>
              <Avatar
                style={{
                  width: 28,
                  height: 28,
                  fontSize: '11px',
                  fontWeight: 700,
                  marginLeft: -8,
                  border: '2px solid #ffffff',
                  backgroundColor: '#e0f2fe',
                  color: '#036dda',
                  zIndex: 0,
                }}
              >
                +{remaining}
              </Avatar>
            </Tooltip>
          )}
        </div>
      </div>
    );
  };

  const handleStatusRow = async (id, nextStatus, row) => {
    const statusLabel = Number(nextStatus) === 1 ? "Active" : "Inactive";
    const targetProject = (projects || []).find((p) => Number(p.id) === Number(id)) || row || {};
    const pName = String(targetProject.project_name || '').trim();

    // Prevent marking Inactive if project has pending (non-Done) tasks
    if (Number(nextStatus) === 0) {
      let tasksPool = allTasks;
      if (!tasksPool || tasksPool.length === 0) {
        try {
          const tRes = await AuthApi.getTasks();
          tasksPool = (tRes && tRes.data) || (Array.isArray(tRes) ? tRes : []) || [];
          setAllTasks(tasksPool);
        } catch (_) {}
      }

      const projectTasks = (tasksPool || []).filter((t) => {
        const tProj = String(t.project_name || '').trim().toLowerCase();
        return tProj === pName.toLowerCase() || (targetProject.id && String(t.project_id) === String(targetProject.id));
      });
      const pendingTasks = projectTasks.filter((t) => {
        const s = String(t.status || '').trim().toLowerCase();
        return s !== 'done' && s !== 'completed';
      });

      if (pendingTasks.length > 0) {
        swal({
          title: "Tasks Pending",
          text: "Please complete all pending tasks before marking as Inactive.",
          icon: "warning",
          buttons: {
            confirm: { text: "OK", className: "tm-btn-primary" }
          }
        });
        return;
      }
    }

    const confirm = await swal({
      title: "Are you sure?",
      text: `Do you want to mark this project as ${statusLabel}?`,
      icon: "warning",
      buttons: ["Cancel", "Yes"],
    });

    if (confirm) {
      swal({
        title: "Loading",
        text: "Please wait...",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        content: createSwalLoaderNode(),
      });

      try {
        const res = await AuthApi.Projectstatusupdate(id, nextStatus);
        if (res && (res.status === true || res.status === 200 || res.success)) {
          setProjects((prev) =>
            prev.map((p) => (Number(p.id) === Number(id) ? { ...p, status: nextStatus, project_status: nextStatus, is_active: nextStatus } : p))
          );
          await fetchData(false);
          swal("Updated!", `Project marked as ${statusLabel} successfully!`, "success");
        } else {
          swal("Tasks Pending", "Please complete all pending tasks before marking as Inactive.", "warning");
        }
      } catch (err) {
        console.error("Error updating project status:", err);
        swal("Error", "Something went wrong while updating project status", "error");
      }
    }
  };

  const handleBulkActionSubmit = async () => {
    if (!selectedBulkAction || selectedProjects.length === 0) {
      swal("Warning", "Please select projects and a bulk action to apply.", "warning");
      return;
    }

    const isMarkingActive = selectedBulkAction === 'active';
    const targetStatus = isMarkingActive ? 1 : 0;

    if (!isMarkingActive) {
      let tasksPool = allTasks;
      if (!tasksPool || tasksPool.length === 0) {
        try {
          const tRes = await AuthApi.getTasks();
          tasksPool = (tRes && tRes.data) || (Array.isArray(tRes) ? tRes : []) || [];
          setAllTasks(tasksPool);
        } catch (_) {}
      }

      for (const pId of selectedProjects) {
        const targetProj = (projects || []).find((p) => Number(p.id) === Number(pId));
        if (targetProj) {
          const pName = String(targetProj.project_name || '').trim();
          const projectTasks = (tasksPool || []).filter((t) => {
            const tProj = String(t.project_name || '').trim().toLowerCase();
            return tProj === pName.toLowerCase() || (targetProj.id && String(t.project_id) === String(targetProj.id));
          });
          const pendingTasks = projectTasks.filter((t) => {
            const s = String(t.status || '').trim().toLowerCase();
            return s !== 'done' && s !== 'completed';
          });
          if (pendingTasks.length > 0) {
            swal({
              title: "Tasks Pending",
              text: `Please complete all pending tasks before marking "${pName}" as Inactive.`,
              icon: "warning"
            });
            return;
          }
        }
      }
    }

    swal({
      title: isMarkingActive ? "Confirm Bulk Active" : "Confirm Bulk Inactive",
      text: isMarkingActive
        ? "Are you sure you want to activate the selected projects?"
        : "Are you sure you want to inactivate the selected projects?",
      className: "holiday-swal",
      buttons: ["Cancel", "OK"],
      dangerMode: !isMarkingActive,
    }).then(async (confirm) => {
      if (confirm) {
        swal({
          title: "Loading",
          text: "Please wait...",
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: createSwalLoaderNode(),
        });

        try {
          const results = await Promise.all(
            selectedProjects.map((id) => AuthApi.Projectstatusupdate(id, targetStatus))
          );
          swal.close();

          const failed = results.find((r) => r && r.status === false);
          if (failed) {
            swal("Tasks Pending", "Please complete all pending tasks before marking as Inactive.", "warning");
            fetchData(false);
            return;
          }

          setProjects((prev) =>
            prev.map((p) =>
              selectedProjects.some((sId) => String(sId) === String(p.id))
                ? { ...p, status: targetStatus, project_status: targetStatus, is_active: targetStatus }
                : p
            )
          );

          setSelectedProjects([]);
          setSelectedBulkAction('');

          // Remove holiday-swal styling class so the success modal is standard HRMS SweetAlert
          const modal = document.querySelector('.swal-modal');
          if (modal) {
            modal.classList.remove('holiday-swal', 'leave-reason-swal');
          }

          swal("Success", isMarkingActive ? "Selected projects marked as Active successfully!" : "Selected projects marked as Inactive successfully!", "success");

          fetchData(false);
        } catch (err) {
          swal.close();
          console.error("Bulk action failed:", err);
          swal("Error", "Something went wrong while updating project statuses.", "error");
        }
      }
    });
  };

  const renderBulkActions = () => {
    return (
      <div className="leave-ticket-bulk-actions">
        <Select
          className="custom-filter-select"
          value={selectedBulkAction}
          onChange={(e) => setSelectedBulkAction(e.target.value)}
          style={{ marginRight: "10px", minWidth: "150px", backgroundColor: "transparent" }}
          displayEmpty
          MenuProps={{ classes: { paper: 'leave-status-menu' } }}
        >
          <MenuItem value="">
            <em>Select Bulk Action</em>
          </MenuItem>
          {statusFilter === 'Active' && (
            <MenuItem value="inactive">Bulk Inactive</MenuItem>
          )}
          {statusFilter === 'Inactive' && (
            <MenuItem value="active">Bulk Active</MenuItem>
          )}
          {statusFilter === 'All' && (
            [
              <MenuItem key="active" value="active">Bulk Active</MenuItem>,
              <MenuItem key="inactive" value="inactive">Bulk Inactive</MenuItem>
            ]
          )}
        </Select>
        <Button
          variant="contained"
          color="primary"
          onClick={handleBulkActionSubmit}
          disabled={selectedProjects.length === 0 || !selectedBulkAction}
        >
          GO
        </Button>
      </div>
    );
  };

  const filteredProjects = projects.filter((p) => {
    const isProjActive = isProjectActive(p.status);
    if (statusFilter === 'Active' && !isProjActive) return false;
    if (statusFilter === 'Inactive' && isProjActive) return false;

    if (searchQuery && searchQuery.trim()) {
      const q = searchQuery.toLowerCase().trim();
      const pName = String(p.project_name || '').toLowerCase();
      const pDesc = String(p.description || p.summary || p.milestone || '').toLowerCase();
      const uids = extractIds(p.member_ids);
      const userMatch = uids.some((uid) => {
        const u = activeUsers.find((user) => Number(user.id) === Number(uid));
        if (!u) return false;
        const name = (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name || '').toLowerCase();
        return name.includes(q);
      });
      return pName.includes(q) || pDesc.includes(q) || userMatch;
    }
    return true;
  });

  const parseToMinutes = (val) => {
    if (!val || typeof val !== 'string') return 0;
    const parsed = parseTimelineHoursMinutes(val);
    if (parsed) {
      return (parsed.h * 60) + parsed.m;
    }
    return 0;
  };

  const calculateProjectTotalTime = (project) => {
    if (!project || !allTasks || allTasks.length === 0) {
      return project?.total_project_time || '00:00 hr';
    }

    const currName = String(project.project_name || '').trim().toLowerCase();
    const currId = Number(project.id || 0);

    const projectTasks = allTasks.filter((t) => {
      const tProj = String(t.project_name || '').trim().toLowerCase();
      const tProjId = Number(t.project_id || t.projectId || 0);
      return (tProj && currName && tProj === currName) || (tProjId && currId && tProjId === currId);
    });

    let totalDoneMinutes = 0;

    projectTasks.forEach((task) => {
      let subTasks = task.sub_tasks_parsed || task.subTasks || task.sub_tasks || [];
      if (typeof subTasks === 'string') {
        try {
          let parsed = JSON.parse(subTasks);
          while (typeof parsed === 'string') {
            parsed = JSON.parse(parsed);
          }
          if (Array.isArray(parsed)) {
            subTasks = parsed;
          }
        } catch (_) {
          subTasks = [];
        }
      }

      const hasSubTasks = Array.isArray(subTasks) && subTasks.length > 0;

      if (hasSubTasks) {
        // 1. If task has subtasks, only sum up completed (Done) subtasks
        // Even if main task is Done, do NOT add main task timeline
        subTasks.forEach((st) => {
          if (!st) return;
          const isDone = String(st.status || '').trim().toLowerCase() === 'done';
          if (isDone) {
            const mins = parseToMinutes(st.timeline);
            if (mins > 0) {
              totalDoneMinutes += mins;
            }
          }
        });
      } else {
        // 2. If task has NO subtasks, main task timeline is counted when the main task itself is marked as 'Done'
        const isMainDone = String(task.status || '').trim().toLowerCase() === 'done';
        if (isMainDone && task.timeline) {
          const mainMins = parseToMinutes(task.timeline);
          if (mainMins > 0) {
            totalDoneMinutes += mainMins;
          }
        }
      }
    });

    const h = Math.floor(totalDoneMinutes / 60);
    const m = totalDoneMinutes % 60;
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')} hr`;
  };

  const tableData = filteredProjects.map((project, index) => {
    const isAct = isProjectActive(project.status);
    return {
      ...project,
      sr_no: index + 1,
      project_name: project.project_name || '-',
      status: isAct ? 1 : 0,
      project_status: isAct ? 1 : 0,
      is_active: isAct ? 1 : 0,
      start_date: formatDate(project.start_date),
      target_date: formatDate(project.target_date),
      assigned_team: renderTeamAvatars(project),
      total_project_time: calculateProjectTotalTime(project),
      summary: (() => {
        const cleanDesc = typeof project.description === 'string'
          ? project.description.replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim()
          : '';
        const text = cleanDesc || project.summary || project.milestone || '-';
        return (
          <div
            style={{
              maxWidth: 240,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
            title={text}
          >
            {text}
          </div>
        );
      })(),
    };
  });

  if (pageLoading) {
    return (
      <div>
        <AuthCheckComponent authToken={props.authToken} />
        <Header {...props} authUser={props.authUser} setAutUser={props.setAutUser} component={<PageLoader />} />
        <Footer />
      </div>
    );
  }

  const pageContent = (
    <div style={{ marginBottom: '24px' }}>
      {/* Breadcrumb Card matching Leave Ticket */}
      <div className="holiday-breadcrumb-card">
        <Breadcrumb
          {...props}
          primaryPageName="Tasks"
          primaryPageLink="/tasks"
          isSecondaryPage={true}
          secondaryPageName="Manage Projects"
        />
      </div>

      {/* Main Table Shell Card using EMS TableComponent */}
      <TableComponent
        shellClassName="holiday-table-shell"
        {...props}
        modelName="Manage Projects"
        addRoute="/addproject"
        tableTh={PROJECT_TABLE_HEADERS}
        tableData={tableData}
        tableCount={filteredProjects.length}
        colNameToShow={['select', 'sr_no', 'project_name', 'start_date', 'target_date', 'assigned_team', 'total_project_time', 'summary']}
        actionBtns={['editNew', 'status', 'delete']}
        statusRow={handleStatusRow}
        handleEditClick={(row) => props.history.push(`/editproject/${row.id}`)}
        removeRow={(id) => handleDeleteProject(id)}
        page={page}
        rowsPerPage={rowsPerPage}
        selected={selectedProjects}
        setSelected={setSelectedProjects}
        bottomBarContent={renderBulkActions()}
        bottomBarClassName="leave-ticket-bottom-bar"
        onPageChange={(newPage) => setPage(newPage)}
        onRowsPerPageChange={(e, newRpp) => {
          let val = 10;
          if (typeof e === 'number') {
            val = e;
          } else if (typeof newRpp === 'number') {
            val = newRpp;
          } else if (e && e.target && e.target.value !== undefined) {
            val = parseInt(e.target.value, 10) || 10;
          }
          setRowsPerPage(val);
          setPage(0);
        }}
        extraHeaderContent={
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap' }}>
            <TextField
              className="users-status-filter"
              select
              label="Projects by Status"
              value={statusFilter}
              onChange={(e) => {
                const val = e.target.value;
                setStatusFilter(val);
                try {
                  ls.set('manage_projects_status_filter', val);
                } catch (_) {}
                setPage(0);
                setSelectedProjects([]);
                setSelectedBulkAction('');
              }}
              variant="outlined"
              style={{
                width: '180px',
                minWidth: '180px',
                maxWidth: '180px',
                flexShrink: 0,
              }}
              InputProps={{
                style: {
                  height: '40px'
                }
              }}
              SelectProps={{
                MenuProps: {
                  disableScrollLock: true,
                  disableRestoreFocus: true,
                  disableAutoFocusItem: true,
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PaperProps: {
                    className: "users-status-menu",
                  },
                },
              }}
            >
              <MenuItem value="All">All Projects</MenuItem>
              <MenuItem value="Active">Active Projects</MenuItem>
              <MenuItem value="Inactive">Inactive Projects</MenuItem>
            </TextField>

            <div className="holiday-search-wrapper" style={{ marginLeft: "auto" }}>
              <TextField
                label="Search"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setPage(0);
                  setSelectedProjects([]);
                }}
                className="holiday-search-field hardik"
                variant="outlined"
                InputLabelProps={{
                  shrink: searchQuery !== "",
                  style: {
                    color: "#036dda",
                    transform:
                      searchQuery !== ""
                        ? "translate(14px, -6px) scale(0.75)"
                        : "translate(14px, 11px) scale(1)",
                    transition: "transform 0.2s ease-in-out",
                  },
                }}
                InputProps={{
                  className: "holiday-search-input",
                  style: {
                    backgroundColor: 'lightgray',
                    borderRadius: '25px',
                    height: "40px"
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      {searchQuery && (
                        <ClearIcon
                          onClick={() => {
                            setSearchQuery('');
                            setPage(0);
                            setSelectedProjects([]);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      )}
                      <SearchIcon
                        style={{ cursor: "pointer" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        }
      />
    </div>
  );

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header {...props} authUser={props.authUser} setAutUser={props.setAutUser} component={pageContent} />
      <Footer />
    </div>
  );
};

export default ManageProjects;
